import { render, staticRenderFns } from "./OsNumeros2024.vue?vue&type=template&id=7e7653a0&scoped=true&"
import script from "./OsNumeros2024.vue?vue&type=script&lang=js&"
export * from "./OsNumeros2024.vue?vue&type=script&lang=js&"
import style0 from "./OsNumeros2024.vue?vue&type=style&index=0&id=7e7653a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7653a0",
  null
  
)

export default component.exports